import React from 'react';
import { Container, Row, Col } from "react-bootstrap";
import { RegisterProvider } from './RegisterContext';
import RightSide from './RightSide'

import "./style.scss";
export default function Registration(props) {

  return (
    <RegisterProvider>
      <Container className="registration">
        <Row className="inner-container">
          {Utils.isMobile() ?
            <React.Fragment>
              <Col md={6} className="p-0">  <img className="basic-image" src={props.labels.image} alt="" /> </Col>
              <Col md={6} className="right"><RightSide {...props} /> </Col>
            </React.Fragment> :
            <React.Fragment>
              <Col md={6} className="right"><RightSide {...props} /> </Col>
              <Col md={6} className="p-0">  <img className="basic-image" src={props.labels.image} alt="" /> </Col>
            </React.Fragment>
          }
        </Row>
      </Container>
    </RegisterProvider>
  )
}